if( document.getElementsByTagName('INPUT') ){

  //toggle password function
  let togglePwd = function( e, pwdInput ){
    if(pwdInput.type == 'password'){
      pwdInput.type = 'text';
      e.target.innerHTML = 'Hide Password';
    } else {
      pwdInput.type = 'password';
      e.target.innerHTML = 'Show Password';
    }
  }

  //set error msg element
  let errorMsgEl = (pwdInput) => {
    let errorEl = null;
    //get error msg cont
    if( pwdInput.parentNode.getElementsByClassName('error_msg').length > 0 ){
      errorEl = pwdInput.parentNode.getElementsByClassName('error_msg')[0];
    } else {
      errorEl = document.createElement('p');
      errorEl.classList.add('error_msg');
      pwdInput.parentNode.appendChild( errorEl );
    }
    return errorEl;
  }

  //strength checker
  let checkStrength = (e) => {
    let pwdInput = e.target;
    let pwd = pwdInput.value;
    let errorEl = errorMsgEl( pwdInput );

    if( pwd.length < 10 ){
      pwdInput.classList.add('error');
      errorEl.innerHTML = 'Passwords must be at least 10 characters in length. The longer, the better!';
    } else {
      pwdInput.classList.remove('error');
      errorEl.innerHTML = '';
    }
  }

  //compare password
  let checkMatch = ( e, compareTo ) => {
    let pwdInput = e.target;
    let errorEl = errorMsgEl( pwdInput );
    if( pwdInput.value !== compareTo.value ){
      pwdInput.classList.add('error');
      errorEl.innerHTML = 'Passwords must match.';
    } else {
      pwdInput.classList.remove('error');
      errorEl.innerHTML = '';
    }
  }



  let pwdEls = document.getElementsByTagName('INPUT');
  [...pwdEls].forEach( function( pwdEl ){
    if (pwdEl.type == 'password') {
      //validate
      if(pwdEl.classList.contains('validate') ){
        pwdEl.addEventListener( 'keyup', (e) => checkStrength( e ) );
      }
      //compare
      if(pwdEl.classList.contains('compare') ){
        let compareTo = document.getElementsByName( pwdEl.getAttribute('data-compare-to') )[0];
        pwdEl.addEventListener( 'keyup', (e) => checkMatch( e, compareTo ) );
      }

      //toggle element
      let toggleButton = document.createElement('button');
      toggleButton.classList.add('toggle-pwd');
      toggleButton.type = 'button';
      let toggleText = document.createTextNode('Show Password');
      toggleButton.appendChild( toggleText );
      pwdEl.parentNode.insertBefore( toggleButton, pwdEl.nextSibling );
      toggleButton.addEventListener( 'click', (e) => togglePwd( e, pwdEl ) );

    }
  })
}
